module.exports = __webpack_public_path__ + "assets/img/299eefdcfb084d5da749f15528012027.svg";